module.exports = __webpack_public_path__ + "static/img/13哆啦A梦.7ab774e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/13哆啦A梦.png
// module id = E1Q2
// module chunks = 1